import { render } from "./ProjectTitleBar.vue?vue&type=template&id=89d4623c"
import script from "./ProjectTitleBar.vue?vue&type=script&lang=js"
export * from "./ProjectTitleBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__